// @flow
import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import TwitterWidgets from 'twitter-widgets';

export default class TweetButton extends Component {
  static propTypes = {
    phrase: PropTypes.string.isRequired,
    spoonerism: PropTypes.string.isRequired,
  };

  timeout = null;

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  shouldComponentUpdate() {
    return false;
  }

  handleButton(button: Object) {
    const buttonNode = findDOMNode(button);
    if (!buttonNode) {
      return;
    }
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      TwitterWidgets.load((twitter) => {
        const url = window.location.toString();
        twitter.widgets.createShareButton(url, buttonNode, {
          hashtags: 'spoonerism',
          related: 'artofspoonerism',
          size: 'large',
          text: this.props.spoonerism,
          via: 'spoonerismorg',
        });
        this.timeout = null;
      });
    }, 300);
  }

  render() {
    const { spoonerism, ...rest } = this.props;
    delete rest.phrase;
    return (
      <div
        {...rest}
        key={spoonerism}
        style={{minHeight: 37}}>
        <div ref={this.handleButton.bind(this)} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TweetButton.js
 **/